enum PhoneType {
  Work = "WorkPhone",
  Cell = "CellPhone",
  Home = "HomePhone",
}

export interface PhoneNumber {
  number: string
  isRequired: boolean
}

export default PhoneType
